<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12" class="p-0">
          <TopBarMember class="mb-0 mb-sm-3" />
        </b-col>
      </b-row>
    </b-container>
    <b-container class="px-0 px-sm-3">
      <b-card
        header-bg-variant="dark"
        header-border-variant="dark"
        header-text-variant="white"
        header-tag="header"
        border-variant="dark"
        class="main-card"
      >
        <template #header class="card-header px-0">
          <router-link to="/">
            <i class="fas fa-chevron-left"></i> หน้าหลัก
          </router-link>
        </template>
        <b-row>
          <b-col class="px-2">
            <h5>
              <i class="fas fa-university"></i> บัญชีธนาคาร
            </h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="px-2">
            <div class="w-100 mt-2 mb-3 border-bottom"></div>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col class="px-2">
            <h3 class="text-secondary font-weight-bold acc-name">
              <b-badge pill>ชื่อบัญชี</b-badge>
              &nbsp;{{profile.bankAccountName}}
            </h3>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="px-2">
            <h6 class="text-secondary">
              <i class="fas fa-money-check"></i> บัญชีธนาคารที่สามารถใช้ได้
            </h6>
          </b-col>
        </b-row>
        <b-row>
          <div
            class="col-6 col-sm-6 col-md-3 col-lg-2 mt-2 text-center px-2"
            v-for="item in userBanks"
            v-bind:key="item.accountNo"
          >
            <label :for="item.accountNo" class="bank-radio w-100" @click="bankSelected = item.accountNo">
              <div
                class="bank-logo p-3 rounded rounded-lg"
                :style="(bankSelected !== undefined && bankSelected == item.accountNo) ? {background: bankInfos[item.bankID-1].color, boxShadow: '0 0 3px 3px ' + bankInfos[item.bankID-1].color} : {background: bankInfos[item.bankID-1].color}"
              >
                <img :src="bankInfos[item.bankID-1].logo" alt="Bank Logo" class="icon-bank bnk48_004" />
              </div>
              <div
                class="p-1 rounded rounded-lg"
                :style="(bankSelected !== undefined && bankSelected == item.accountNo) ? {background: bankInfos[item.bankID-1].color} : []"
                :class="(bankSelected !== undefined && bankSelected == item.accountNo) ?  'p-1 rounded-bottom text-right' : 'p-1 rounded rounded-lg'"
              >
                <span
                  :class="(bankSelected !== undefined && bankSelected == item.accountNo) ?  'text-white font-weight-bold' : ''"
                >ธ.{{bankInfos[item.bankID-1].title}}</span>
                <b-badge
                  variant="dark"
                  :class="(bankSelected !== undefined && bankSelected == item.accountNo) ?  'font-weight-bold w-100 text-right' : 'font-weight-bold w-100'"
                >{{item.accountNo}}</b-badge>
                <div
                  class="check-icon rounded-circle text-white"
                  v-if="bankSelected == item.accountNo"
                  :style="{background: bankInfos[item.bankID-1].color}"
                >
                  <i class="fas fa-check-circle fa-md"></i>
                </div>
              </div>
            </label>
          </div>
        </b-row>
        <b-row>
          <b-col class="px-2">
            <div class="w-100 mt-4 mb-3 border-bottom"></div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6" class="px-2">
            <b-button variant="primary" block to="/member/settings/bank/status">
              <i class="fas fa-tasks"></i> เช็คสถานะบัญชี
            </b-button>
          </b-col>
          <b-col cols="6" class="px-2">
            <b-button variant="success" block to="/member/settings/bank/add">
              <i class="fas fa-plus"></i> เพิ่มบัญชี
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="px-2">
            <div class="w-100 mt-4 mb-3 border-bottom"></div>
          </b-col>
        </b-row>
      </b-card>
    </b-container>
    <FooterIndex class="mt-3" />
  </div>
</template>

<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";

// Include Component
import TopBarMember from "@/components/TopBarMember.vue";
import FooterIndex from "@/components/Footer.vue";

export default {
  name: "Bank",
  props: ["page"],
  components: {
    TopBarMember,
    FooterIndex
  },
  data() {
    return {
      bankSelected: null,
      userBanks: [],
      bankInfos: [
        {
          bankID: 1,
          code: "BBL",
          title: "กรุงเทพ",
          logo: require('../../../assets/images/bank-icon/bbl.svg'),
          color: "#1e4598"
        },
        {
          bankID: 2,
          code: "KBANK",
          title: "กสิกรไทย",
          logo: require('../../../assets/images/bank-icon/kbank.svg'),
          color: "#138f2d"
        },
        {
          bankID: 3,
          code: "KTB",
          title: "กรุงไทย",
          logo: require('../../../assets/images/bank-icon/ktb.svg'),
          color: "#1ba5e1"
        },
        {
          bankID: 4,
          code: "SCB",
          title: "ไทยพาณิชย์",
          logo: require('../../../assets/images/bank-icon/scb.svg'),
          color: "#4e2e7f"
        },
        {
          bankID: 5,
          code: "BAY",
          title: "กรุงศรีอยุธยา",
          logo: require('../../../assets/images/bank-icon/bay.svg'),
          color: "#fec43b"
        },
        {
          bankID: 6,
          code: "CIMB",
          title: "ซีไอเอ็มบี",
          logo: require('../../../assets/images/bank-icon/cimb.svg'),
          color: "#7e2f36"
        },
        {
          bankID: 7,
          code: "GSB",
          title: "ออมสิน",
          logo: require('../../../assets/images/bank-icon/gsb.svg'),
          color: "#eb198d"
        },
        {
          bankID: 8,
          code: "KIATNAKIN",
          title: "เกียรตินาคิน",
          logo: require('../../../assets/images/bank-icon/kk.svg'),
          color: "#199cc5"
        },
        {
          bankID: 9,
          code: "LHBANK",
          title: "แลนด์ แอนด์ เฮาส์",
          logo: require('../../../assets/images/bank-icon/lhb.svg'),
          color: "#6d6e71"
        },
        {
          bankID: 10,
          code: "STANDARD",
          title: "สแตนดาร์ดชาร์เตอร์ด (ไทย)",
          logo: require('../../../assets/images/bank-icon/sc.svg'),
          color: "#0f6ea1"
        },
        {
          bankID: 11,
          code: "THANACHART",
          title: "ธนชาติ",
          logo: require('../../../assets/images/bank-icon/tbnk.svg'),
          color: "#fc4f1f"
        },
        {
          bankID: 12,
          code: "TISCO",
          title: "ทิสโก้",
          logo: require('../../../assets/images/bank-icon/tisco.svg'),
          color: "#12549f"
        },
        {
          bankID: 13,
          code: "TMB",
          title: "ทหารไทย",
          logo: require('../../../assets/images/bank-icon/tmb.svg'),
          color: "#1279be"
        },
        {
          bankID: 14,
          code: "UOB",
          title: "ยูโอบี",
          logo: require('../../../assets/images/bank-icon/uob.svg'),
          color: "#0b3979"
        }
      ],
      profile: {
        username: "aloneruay",
        firstname: "ชมด",
        lastname: "วงษ์สารสิน",
        birthdate: "2000-08-12",
        email: "test@test.com",
        mobile: "0657986543"
      }
    };
  },
  mounted() {
    this.getProfile();
  },
  methods: {
    getProfile() {
      axios
        .post(
          this.getApiUrl + "/customer/getcurrentfinance",
          {
            username: this.getUsername
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername
            }
          }
        )
        .then(response => {
          this.profile = response.data.data;
          axios
            .post(
              this.getApiUrl + "/cash/getallBankAccount",
              {
                username: this.getUsername
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  token: this.getAccessToken,
                  username: this.getUsername
                }
              }
            )
            .then(response => {
              this.userBanks = response.data.data;
              console.log("User Banks", response);
            });
        });
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getApiUrl: "getApiUrl"
    })
  }
};
</script>

<style lang="scss" scoped>
.main-card {
  min-height: calc((100vh - 104px) - 49px);
}

.acc-name {
  line-height: 35px;
}

.avatar-preview {
  border-radius: 50px;
  overflow: hidden;
  height: 80px;
  width: 80px;
}

.button-upload-file {
  position: relative;
  cursor: pointer;

  input {
    width: 1px;
    height: 1px;
    display: block;
    position: absolute;
    top: -100%;
    left: -100%;
  }

  .icon {
    height: 32px;
    width: 32px;
    background: #3b5898;
    position: absolute;
    z-index: 2;
    bottom: 0px;
    right: 0px;
    text-align: center;
    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 50px;
    padding: 5px 0px 0px 1px;
  }
}

.card-header {
  font-size: 90%;
  line-height: 90%;

  a {
    color: #bbbbbb;

    &:hover {
      color: #bd841b;
      text-decoration: none;
    }
  }
}

h5 {
  color: #bd841b;
  font-weight: bold;
}

.credit-balance {
  background-color: #d4edda !important;
  border-color: #c3e6cb;
  font-size: 30px;
  line-height: 40px;
  height: 48px;

  :focus {
    outline: none;
  }
}

.input-hidden {
  position: absolute;
  left: -9999px;
}

.bank-logo {
  border: 1px solid #fff;
  img {
    width: 70px;
  }
}

.check-icon {
  position: absolute;
  bottom: 9px;
  left: 17px;
  border: 2px #fff solid;
  padding: 2px 4px 0px 5px;
}
</style>